// import React from "react";
// import { FaInfoCircle } from "react-icons/fa";
// import { Tooltip } from "react-tooltip";
// import "react-tooltip/dist/react-tooltip.css";

// export const Input = React.memo(
//   ({
//     label,
//     name,
//     type = "text",
//     value = "",
//     placeholder = undefined,
//     onChange,
//     disabled,
//     required,
//     isReport,
//     tooltip, // 👈 received from parent
//     ...rest
//   }) => {
//     value = type === "date" ? (value === "" ? new Date() : value) : value;
//     placeholder = placeholder || label;

//     if (isReport) {
//       return (
//         <p>
//           {label}
//           {required && "*"}: {value}
//         </p>
//       );
//     }

//     return (
//       <div className="form-group">
//         <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//           {label}
//           {required && "*"}
//           {tooltip && (
//             <>
//               <span
//                 data-tooltip-id={`tooltip-${name}`}
//                 data-tooltip-content={tooltip}
//                 style={{ cursor: "pointer" }}
//               >
//                 <FaInfoCircle size={14} color="#07b1b0" />
//               </span>
//               <Tooltip id={`tooltip-${name}`} place="right" />
//             </>
//           )}
//         </label>

//         <input
//           type={type}
//           name={name}
//           placeholder={placeholder || ""}
//           value={value}
//           onChange={onChange}
//           disabled={disabled}
//           required={required}
//           {...rest}
//         />
//       </div>
//     );
//   }
// );



import React from "react";
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { useTooltips } from "../../hooks/toolTips"; // Adjust path if needed

// const getTooltip = (tooltips, label, name) => {
//   if (!Array.isArray(tooltips)) return "";
//   const match = tooltips.find(
//     (t) =>
//       (label && t.Label?.toLowerCase() === label.toLowerCase()) ||
//       (name && t.Name?.toLowerCase() === name.toLowerCase())
//   );
//   return match?.Tooltip && match.Tooltip !== "123" ? match.Tooltip : "";
// };

const getTooltip = (tooltips, label, name) => {
  if (!Array.isArray(tooltips)) {
    console.warn("❌ Tooltips is not an array:", tooltips);
    return "";
  }

  const match = tooltips.find(
    (t) =>
      (label && t.Label?.toLowerCase().trim() === label.toLowerCase().trim()) ||
      (name && t.Name?.toLowerCase().trim() === name.toLowerCase().trim())
  );

  if (!match) {
    console.log(`🔍 No tooltip match found for label="${label}" name="${name}"`);
    return "";
  }

  let tooltipText = match.Tooltip?.trim();
  console.log(`🧩 Found tooltip for "${label || name}": "${tooltipText}"`);

  if (!tooltipText || tooltipText.toLowerCase() === "123" || tooltipText.length < 7) {
    console.log("⚠️ Tooltip skipped (too short or invalid):", tooltipText);
    return "";
  }
// Normalize all line breaks
  tooltipText = tooltipText
    .replace(/<br\s*\/?>/gi, "\n") // HTML <br> to newline
    .replace(/\r\n/g, "\n");       // Windows newline to Unix newline
  return tooltipText;
};

export const Input = React.memo(
  ({
    label,
    name,
    type = "text",
    value = "",
    placeholder = undefined,
    onChange,
    disabled,
    required,
    isReport,
    tooltip, // optional manual override
    ...rest
  }) => {
    const tooltips = useTooltips();
    const labelText = typeof label === "string" ? label : "";
    const resolvedTooltip = tooltip || getTooltip(tooltips, labelText.replace(/:$/, ""), name);

    value = type === "date" ? (value === "" ? new Date() : value) : value;
    placeholder = placeholder || labelText;

    if (isReport) {
      return (
        <p>
          {label}
          {required && "*"}: {value}
        </p>
      );
    }

    return (
      <div className="form-group">
        <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {label}
          {required && "*"}
          {resolvedTooltip && (
            <>
              <span
                data-tooltip-id={`tooltip-${name}`}
                style={{ cursor: "pointer" }}
              >
                <FaInfoCircle size={14} color="#07b1b0" />
              </span>
              <Tooltip
                id={`tooltip-${name}`}
                place="right"
                className="custom-tooltip clickable-tooltip"
                openOnClick={true}
                clickable={true}
                globalCloseEvents={{ clickOutsideAnchor: true }}
              >
                <div className="tooltip-text" dangerouslySetInnerHTML={{ __html: resolvedTooltip.replace(/\n/g, "<br/>") }} />
              </Tooltip>
            </>
          )}
        </label>

        <input
          type={type}
          name={name}
          placeholder={placeholder || ""}
          value={value}
          onChange={onChange}
          disabled={disabled}
          required={required}
          {...rest}
        />
      </div>
    );
  }
);
